import React, { memo, ReactElement } from 'react';
import get from 'lodash/get';

const DefaultCell = <TData extends {}>({ field, data }: CellProps<TData>): ReactElement => (
  <div>{get(data, field, '')}</div>
);

export default memo(DefaultCell);
